import WebinarBanner from '@components/webinar-banner';
import StudioBanner from '@invideoio/web-shared/components/StudioBanner';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';

import { BANNER_MODE, BannerMode } from '@constants/common';

interface BannerSlotProps {
  browser?: BrowserType;
  // When set, the banner is hidden on mobile in both modes — keeps desktop-only
  // mounts symmetric across webinar/studio.
  desktopOnly?: boolean;
  platform?: PlatformType;
}

// Renders the active top banner from BANNER_MODE (webinar wrapper, or the
// StudioBanner "normal" fallback). Flip BANNER_MODE to switch every mount.
const BannerSlot = ({ browser, desktopOnly, platform }: BannerSlotProps) => {
  if (desktopOnly && platform === PlatformType.Mobile) return null;
  return BANNER_MODE === BannerMode.Webinar ? (
    <WebinarBanner browser={browser} />
  ) : (
    <StudioBanner browser={browser} />
  );
};

export default BannerSlot;
